import intersectionHelper from '../../../general/js/intersection-helper';
import PersistentConnector from '../../../general/js/persistent-connector';
import $waypoints from '../../../general/js/jquery.waypoints';
import waypoints from '../../../general/js/noframework.waypoints';
import inview from '../../../general/js/inview';
import app from '../../../general/js/app';

let callbackName = 'onGmapLoad';
let googleMapsApiKey = app.getConfig('googleMapsApiKey');
let isLoaded = false;
let onloadQueue = [];
let connector;

window[callbackName] = () => {
    isLoaded = true;
    onloadQueue.forEach(callback => callback());
};

export default function onReady(callback) {
    if (isLoaded) {
        callback();
    } else {
        onloadQueue.push(callback);
    }
}

function insertScript() {
    let script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.onerror = function () {
        connector.recover();
    };
    script.src = `https://maps.googleapis.com/maps/api/js?v=2.exp&sensor=false&callback=${callbackName}&key=${googleMapsApiKey}&channel=01`;
    let s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(script, s);
}

function initGmapScriptLoading(){
    if(!isLoaded) {
        connector = new PersistentConnector(insertScript, {name: 'Gmap script'});
        insertScript();
    }
}

//postload the lot details dynamic map on click of the static map
var lotDetailsStaticMap = document.getElementById('lot-details-static-map');

if(document.querySelector('[data-dc="gmap"]')) {
    console.log("document.querySelector('[data-dc=\"gmap\"]') fired");
    //load the map when visible in the viewport, unless the map has a postload flag set to true (lot details map postloads)
    if (!document.querySelector('[data-postload-map="true"]')) {
        intersectionHelper.enterViewportOnce(document.querySelector('[data-dc="gmap"]'), initGmapScriptLoading);
    }
    else {
        if (lotDetailsStaticMap !== undefined && lotDetailsStaticMap != null) {
            var result = new Waypoint.Inview({
                element: lotDetailsStaticMap,
                enter: function () {
                    var mapLoaded = lotDetailsStaticMap.dataset.mapLoaded === 'true';
                    if (!mapLoaded) {
                        var lat = lotDetailsStaticMap.dataset.lat;
                        var lng = lotDetailsStaticMap.dataset.lng;
                        var url = `url('https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=15&channel=01&scale=1&size=845x200&maptype=roadmap&key=${googleMapsApiKey}&format=png&visual_refresh=true&markers=size:mid%7Ccolor:0xff0000%7Clabel:%7C${lat},${lng}')`;
                        lotDetailsStaticMap.style.backgroundImage = url;
                        lotDetailsStaticMap.style.backgroundPosition = "center";
                        lotDetailsStaticMap.dataset.mapLoaded = true;
                    }
                }
            });
        }
    }

    if(document.querySelector('.js-print')){
        document.querySelector('.js-print').addEventListener('click', (e) =>{
            e.preventDefault();
            initGmapScriptLoading();
            if (isLoaded) {
                window.print();
            } else {
                onloadQueue.push(() => {
                    setTimeout(() => {window.print();}, 500);
                });
            }
        });
    }
}

if (lotDetailsStaticMap) {

    lotDetailsStaticMap.addEventListener('click', function (e) {

        e.preventDefault();
        lotDetailsStaticMap.style.display = 'none';
        var lotDetailsDynamicMap = document.querySelector('[data-dc="gmap"]');

        if (lotDetailsDynamicMap)
            lotDetailsDynamicMap.style.display = 'block';

        initGmapScriptLoading();
    });
}




// WEBPACK FOOTER //
// ./app/components/gmap/js/loadGmap.js